import { Pipe, PipeTransform, inject } from '@angular/core';
import { TimelinePresenceService } from '@wilson/non-domain-specific/realtime-collaboration/live-viewers';
import { Observable, map, of } from 'rxjs';

@Pipe({
  name: 'shiftPresenceBorderColor',
  standalone: true,
})
export class ShiftPresenceBorderColorPipe implements PipeTransform {
  private readonly timelinePresenceService = inject(TimelinePresenceService);

  transform(shiftId: string): Observable<string | null> {
    return of(null);
    // TODO: in the next iteration, we will implement color border for all shifts that have current users viewing them, https://menlo1679.atlassian.net/browse/WILP-12750.
    // This code is temporary commented out to avoid visual bugs mentioned here https://gitlab.com/menlo79/wilson/-/merge_requests/6356#note_3550528587
    // return this.timelinePresenceService.shiftViewerBorderColorById$.pipe(
    //   map((borderColorByShiftId) => borderColorByShiftId[shiftId] ?? null),
    // );
  }
}
